import { withDefault } from '@weft/utils';
import { deserializeNumberParam,
  serializeNumberParam } from '../../utils/params-formatting';
import { INVOICES_OVERVIEWS_PAGE_SIZE } from '../requests/use-invoices-overviews/use-invoices-overviews-consts';
import { useStateParams } from '../use-state-params';

export function usePageSizeParam(defaultPageSize?: number) {
  const pageSize = withDefault(defaultPageSize, INVOICES_OVERVIEWS_PAGE_SIZE);

  return useStateParams<number>(pageSize, 'pageSize', serializeNumberParam, deserializeNumberParam);
}